import React, { ReactElement, useEffect, useState } from 'react';
import CcxComponentProps from '../../../../core/CcxComponent';
import Service from '../../../../types/Service';
import styles from './ServiceResources.module.less';
import { Tooltip } from 'antd';
import DeploymentsItem from '../../../../types/DeploymentsItem';
import InstanceSize from '../../../../types/InstanceSize';
import useContentInstanceSizes from '../../../../core/hooks/useContentInstanceSizes';
import LazyLoader from '../../../LazyLoader';
interface Props extends CcxComponentProps {
    service?: Service;
    dataStore?: DeploymentsItem;
}

function ServiceResources({ dataStore, service }: Props): ReactElement {
    const [instanceSize, setInstanceSize] = useState<InstanceSize[]>();

    let cloudProvider = service && service.getCloudProvider();
    const { instanceSizes, loading } = useContentInstanceSizes(cloudProvider);

    useEffect(() => {
        if (service && instanceSizes) {
            const instance = instanceSizes[0]?.production?.filter(
                (s: InstanceSize) => s.type === service?.getInstanceType()
            );
            setInstanceSize(instance);
        }
    }, [instanceSizes, service]);

    return (
        <>
            {loading ? (
                <LazyLoader type="row" rows={1} />
            ) : (
                instanceSize && (
                    <div>
                        <div>
                            <span className={styles.ServiceResourceslabel}>
                                Instance:{' '}
                            </span>
                            {instanceSize[0]?.name || ''}
                            <Tooltip title="CPU">
                                {` (${instanceSize[0].cpu || ''} Cores, `}
                            </Tooltip>
                            <Tooltip title="RAM">
                                {`${instanceSize[0].ram || ''} GB)`}
                            </Tooltip>
                        </div>
                        {dataStore?.volumeType !== '' && (
                            <div>
                                <span className={styles.ServiceResourceslabel}>
                                    Volume:{' '}
                                </span>
                                {`${dataStore?.volumeType || ''} `}
                                <Tooltip title="Storage">
                                    {`(${dataStore?.volumeSize || ''}GB)`}
                                </Tooltip>
                            </div>
                        )}
                    </div>
                )
            )}
        </>
    );
}

export default ServiceResources;
